import React, { Component } from "react";
import classnames from "classnames";

import { getUserNameForAvatar, addLandaSize } from "Utils";
import { TTP_API_URL } from "Config";

import _ from "i18n";

export default class User extends Component {
  renderAvatar() {
    const {
      avatar,
      avatarUrl,
      onSelected,
      id,
      firstName,
      lastName,
      isSelected
    } = this.props;

    const checkDiv = (
      <div className={classnames("author-check", isSelected && "active")}>
        <i id={`check-${id}`} />
      </div>
    );

    if (avatarUrl || avatar) {
      return (
        <div
          id={`avatar-${id}`}
          className={classnames("author-avatar", isSelected && "selected")}
          onClick={onSelected}
          style={{
            backgroundImage: `url(${
              avatarUrl
                ? addLandaSize(avatarUrl, 260)
                : TTP_API_URL + "/" + avatar
            })`
          }}
        >
          {checkDiv}
        </div>
      );
    }

    return (
      <div
        id={`avatar-${id}`}
        className={classnames(
          "author-avatar empty-avatar",
          isSelected && "selected"
        )}
        onClick={onSelected}
      >
        <span>{getUserNameForAvatar(firstName, lastName)}</span>
        {checkDiv}
      </div>
    );
  }

  renderSignature() {
    const {
      firstName,
      lastName,
      role,
      blogRoleInOrganization,
      defaultSignature,
      header
    } = this.props;

    let defaultSignatureDiv = [];
    let title = "";
    let head = "";
    // defaultSignatureDiv.push(<div>);
    if (defaultSignature && defaultSignature.title) {
      title = <h3 key="h3">{defaultSignature.title}</h3>;
    } else {
      title = <h3 key="h3">{firstName + " " + lastName}</h3>;
    }

    if (defaultSignature && defaultSignature.head) {
      head = <h4 key="h4">{defaultSignature.head}</h4>;
    } else if (header) {
      head = <h4 key="h4">{header}</h4>;
    }
    defaultSignatureDiv.push(
      <div>
        {title} {head}
      </div>
    );

    if (blogRoleInOrganization && blogRoleInOrganization.length > 0) {
      defaultSignatureDiv.push(
        <h5 key="h5">
          <span>
            {_(blogRoleInOrganization[0].role)}
            {blogRoleInOrganization[0].role !== "CHIEF_EDITOR" && (
              <span className="mandated">
                ({blogRoleInOrganization[0].mandated
                  ? _("Mandated")
                  : _("Not Mandated")})
              </span>
            )}
          </span>
        </h5>
      );
    } else if (role && role.id) {
      defaultSignatureDiv.push(<h5 key="h5">{_(role.type)}</h5>);
    }
    return defaultSignatureDiv;
  }

  render() {
    return (
      <div className="author">
        {this.renderAvatar()}
        <div className="author-header">{this.renderSignature()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/User.js